/**
 * Oeffnet/schliesst das Fitment-Konfigurator-Modal im Header. Die eigentliche
 * Picker-Logik lebt in fitment-configurator.js und wird erst beim ersten
 * Oeffnen per window.ZrFitmentInit initialisiert (siehe dort — kein Aufruf
 * auf jeder Seitenansicht).
 *
 * Mehrere Trigger moeglich (Desktop-Redesign-Header UND der klassische
 * Mobile-Header aus sections/header.liquid, die je nach Breite per CSS
 * alternativ gezeigt werden — beide Sections sind aber IMMER im DOM) — daher
 * ueber [data-fit-trigger] statt einer festen ID, die es nur einmal geben
 * duerfte.
 */
(function () {
  var triggers = document.querySelectorAll("[data-fit-trigger]");
  var modal = document.getElementById("zrFitModal");
  if (!triggers.length || !modal) return;

  var closeBtn = modal.querySelector("[data-fit-modal-close]");
  var backdrop = modal.querySelector("[data-fit-modal-backdrop]");
  var content = modal.querySelector("[data-fitment-configurator]");
  var lastTrigger = triggers[0];

  function open(e) {
    lastTrigger = e.currentTarget;
    modal.classList.add("is-open");
    document.body.style.overflow = "hidden";
    if (window.ZrFitmentInit && content) window.ZrFitmentInit(content);
    closeBtn.focus();
  }
  function close() {
    modal.classList.remove("is-open");
    document.body.style.overflow = "";
    lastTrigger.focus();
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener("click", open);
  });
  closeBtn.addEventListener("click", close);
  backdrop.addEventListener("click", close);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.classList.contains("is-open")) close();
  });
})();
